export const AchievementsData = [
    {
        id: 1,
        coverImg: "https://live.staticflickr.com/65535/52321113182_d1eacd7d43_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322375840_7292785490_c.jpg",
    },
    // {
    //     id: 2,
    //     coverImg: "",
    //     hoverImg: "",
    // },
    {
        id: 3,
        coverImg: "https://live.staticflickr.com/65535/52322337669_267735133b_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322250783_94b381cb85_c.jpg",
    },
    {
        id: 4,
        coverImg: "https://live.staticflickr.com/65535/52321112987_574ca78fb5_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52321934851_f1c6600d99_c.jpg",
    },
    {
        id: 5,
        coverImg: "https://live.staticflickr.com/65535/52322230673_6b3f4c7195_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322357649_553d719611_c.jpg",
    },
    // {
    //     id: 6,
    //     coverImg: "",
    //     hoverImg: "",
    // },
    // {
    //     id: 7,
    //     coverImg: "",
    //     hoverImg: "",
    // },
    {
        id: 8,
        coverImg: "https://live.staticflickr.com/65535/52322355125_69dc76c8b4_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322375565_39cedbace5_c.jpg",
    },
    {
        id: 9,
        coverImg: "https://live.staticflickr.com/65535/52322337349_07bb0215e0_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322357519_4ab59d3e78_c.jpg",
    },
    {
        id: 10,
        coverImg: "https://live.staticflickr.com/65535/52321112822_fa916dd259_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322250413_a21834be0e_c.jpg",
    },
    {
        id: 11,
        coverImg: "https://live.staticflickr.com/65535/52321112742_872a28e37e_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52321132652_fa563cbcec_c.jpg",
    },
    {
        id: 12,
        coverImg: "https://live.staticflickr.com/65535/52322354885_253f8edf14_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322357324_f9f3d1e263_c.jpg",
    },
    {
        id: 13,
        coverImg: "https://live.staticflickr.com/65535/52321914391_de3ff65116_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322357269_a87e03130d_c.jpg",
    },
    {
        id: 14,
        coverImg: "https://live.staticflickr.com/65535/52321914351_9ab49210f0_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52321132442_e00a8056e6_c.jpg",
    },
    {
        id: 15,
        coverImg: "https://live.staticflickr.com/65535/52322354745_a1ae5f08ed_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322375115_8a5cd5e705_c.jpg",
    },
    {
        //cover mein todi garbari hai 
        id: 16,
        coverImg: "https://live.staticflickr.com/65535/52322354730_46d2b08521_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52321934176_e8fa4e40f4_c.jpg",
    },
    {
        id: 17,
        coverImg: "https://live.staticflickr.com/65535/52322356490_9ed8cf8ee2_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52321132277_70980994de_c.jpg",
    },
    // {
    //     id: 18,
    //     coverImg: "",
    //     hoverImg: "",
    // },
    {
        id: 19,
        coverImg: "https://live.staticflickr.com/65535/52322356435_f3d7fd424b_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52321934116_3603f1cf35_c.jpg",
    },
    {
        id: 20,
        coverImg: "https://live.staticflickr.com/65535/52321114072_e7349bb0a6_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322374945_1fa06f2c25_c.jpg",
    },
    {
        id: 21,
        coverImg: "https://live.staticflickr.com/65535/52322231898_f677f68fab_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322249848_17704fc09c_c.jpg",
    },
    {
        id: 22,
        coverImg: "https://live.staticflickr.com/65535/52322338589_6b7470eaec_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322356764_f99fa8fc55_c.jpg",
    },
    // {
    //     id: 23,
    //     coverImg: "",
    //     hoverImg: "",
    // },
    {
        id: 24,
        coverImg: "https://live.staticflickr.com/65535/52321915786_56e47d3596_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52321933881_55617b84d6_b.jpg",
    },
    {
        // not that bad but photo quality issue
        id: 25,
        coverImg: "https://live.staticflickr.com/65535/52321915756_18a7b8d49f_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322374700_cf411e0df7_b.jpg",
    },
    {
        // not that bad but photo quality issue
        id: 26,
        coverImg: "https://live.staticflickr.com/65535/52321915701_47c0cb3cbf_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52321134042_1d5d475426_b.jpg",
    },
    {
        //photo quality not good
        id: 27,
        coverImg: "https://live.staticflickr.com/65535/52321113787_578c987205_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52321935841_c2e6ff26a2_b.jpg",
    },
    {
        // not that bad but photo quality issue
        id: 28,
        coverImg: "https://live.staticflickr.com/65535/52321915616_fa3046bc79_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322251783_1bbd223e88_b.jpg",
    },
    {
        id: 29,
        coverImg: "https://live.staticflickr.com/65535/52321915586_7da2026e37_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322376750_9b6bbe894e_b.jpg",
    },
    {
        id: 30,
        coverImg: "https://live.staticflickr.com/65535/52322355965_a7620fb03f_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52321133862_864302a2f5_b.jpg",
    },
    {
        id: 31,
        coverImg: "https://live.staticflickr.com/65535/52322338219_8860d0124b_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322251598_505c0793bb_b.jpg",
    },
    {
        id: 32,
        coverImg: "https://live.staticflickr.com/65535/52322231393_c15977896c_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322251558_9634c55ff5_b.jpg",
    },
    {
        id: 33,
        coverImg: "https://live.staticflickr.com/65535/52322231368_b63034d341_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322251498_f2038dbaa8_b.jpg",
    },
    {
        id: 34,
        coverImg: "https://live.staticflickr.com/65535/52321915391_9bd0bd6588_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322251438_aa90db01ba_b.jpg",
    },
    {
        id: 35,
        coverImg: "https://live.staticflickr.com/65535/52321113507_2ba38a8c07_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322251398_461fc1cc30_b.jpg",
    },
    {
        id: 36,
        coverImg: "https://live.staticflickr.com/65535/52321113482_b7622719f5_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52321133512_5a0931ebd5_b.jpg",
    },
    {
        id: 37,
        coverImg: "https://live.staticflickr.com/65535/52322231238_10e978a6cc_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52321935336_da355cbd07_b.jpg",
    },
    {
        id: 38,
        coverImg: "https://live.staticflickr.com/65535/52321915241_d54a30d50a_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52321935301_5e976186ea_b.jpg",
    },
    {
        id: 39,
        coverImg: "https://live.staticflickr.com/65535/52321113317_a92cdf12d6_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322251188_b08884895c_b.jpg",
    },
    {
        id: 40,
        coverImg: "https://live.staticflickr.com/65535/52321915161_32dc655b78_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52321935176_71b26d93ea_b.jpg",
    },
    {
        id: 41,
        coverImg: "https://live.staticflickr.com/65535/52322337809_42756d3760_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322357934_8ac6cba663_b.jpg",
    },
    {
        id: 42,
        coverImg: "https://live.staticflickr.com/65535/52321915031_42cc41b66f_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52321935066_16c3ed83d7_b.jpg",
    },
    {
        id: 43,
        coverImg: "https://live.staticflickr.com/65535/52322337764_ba1a78a216_b.jpg",
        hoverImg: "https://live.staticflickr.com/65535/52322250958_052b2483ce_b.jpg",
    },

]